import * as R from "ramda";

export const lowerOrNull = a => a ? a.toLocaleLowerCase() : null;

export const simpleSort = (a, b, c = 0) => a > b ? 1 : a < b ? -1 : c;

export const simpleSortNullsLast = (a, b, c = 0) => a === null ? 1 : b === null ? -1 : a > b ? 1 : a < b ? -1 : c;

export function nameSort(a, b) {
  return simpleSort(lowerOrNull(a.firstname), lowerOrNull(b.firstname),
    simpleSort(lowerOrNull(a.lastname), lowerOrNull(b.lastname),
      simpleSort(lowerOrNull(a.email), lowerOrNull(b.email))));
}

export function dateSort(path, descending) {
  if (descending)
    return (x2, x1) => {
      let p1 = R.path(path, x1);
      let p2 = R.path(path, x2);
      if (!p1 && !p2) return 0;
      if (!p1) return -1;
      if (!p2) return 1;
      return p1.diff(p2);
    };
  else
    return (x1, x2) => {
      let p1 = R.path(path, x1);
      let p2 = R.path(path, x2);
      if (!p1 && !p2) return 0;
      if (!p1) return -1;
      if (!p2) return 1;
      return p1.diff(p2);
    };
}

export const numerAlnumComp = (a, b) => {
  const a_val = parseInt(a);
  const b_val = parseInt(b);
  if (a_val && b_val) {
    return b_val - a_val;
  }
  return a_val ? -1 : b_val ? 1 : a.localeCompare(b);
}



// WEBPACK FOOTER //
// ./src/common/sorters.js